function addQuantityByMultiples(el, min, max, multiples, action) {
  var $amountInput = $(el).closest('.quantity').find('.amount');
  var value = parseFloat($amountInput.val());
  if (isNaN(value)) {
      return false;
  }
  var min = parseFloat(min);
  var max = parseFloat(max);
  var multiples = parseFloat(multiples);
  if (action === 'increase') {
      value += multiples;
  } else if (action === 'decrease') {
      value -= multiples;
  }
  if (value < min) {
      value = min;
  } else if (value > max) {
      value = max;
  }


  $amountInput.data('quantity', value);
  $amountInput.val(value)
  return true;
}
$('html').on('click', '.increase', function () {
  var min = $(this).closest('.quantity').find('.amount').data('min');
  var max = $(this).closest('.quantity').find('.amount').data('max');
  var multiples = min - 1;
  addQuantityByMultiples(this, min, max, multiples, 'increase');
});

$('html').on('click', '.decrease', function () {
  var min = $(this).closest('.quantity').find('.amount').data('min');
  var max = $(this).closest('.quantity').find('.amount').data('max');
  var multiples = min - 1;
  addQuantityByMultiples(this, min, max, multiples, 'decrease');
});

$(document).ready(function(){
  if($('#variants').length>0){
      $('.table-row').append('<div class="multiply-text"></div>')
  }
  else{
      $('.add-to-cart').after('<div class="multiply-text"></div>')
  }
  $('.quantity').on('input', function(){

      val = $(this).find('.amount').val()
      data_min = $(this).find('.amount').data('min')
      nasobek = Math.round(val/data_min) 
      remainder = val % data_min
      vypocet = nasobek*data_min
      if (remainder == 0){
          if($('#variants').length>0){
              $(this).closest('.table-row').find('.multiply-text').html('')
              $(this).closest('.table-row').find('body').removeClass('disabled-add-to-cart')
          }
          else{
              $('.multiply-text').html('')
              $('body').removeClass('disabled-add-to-cart')
          }
      } else {
          if($('#variants').length>0){
              $(this).closest('.table-row').find('.multiply-text').html('Do košíku můžete vložit pouze násobky čísla '+data_min+'.')
              $(this).closest('.table-row').find('body').addClass('disabled-add-to-cart')
          }
          else{
              $('.multiply-text').html('Do košíku můžete vložit pouze násobky čísla '+data_min+'.')
              $('body').addClass('disabled-add-to-cart')
          }
          //$(this).find('.amount').val(vypocet)
      }
  })
  if($('.id--9').length){
    $('.quantity input.amount').attr('readonly','true');
}
})

